import { render, staticRenderFns } from "./NatureTravaux.vue?vue&type=template&id=41c5f13a&scoped=true"
import script from "./NatureTravaux.vue?vue&type=script&lang=js"
export * from "./NatureTravaux.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c5f13a",
  null
  
)

export default component.exports